import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './Header';

function Register() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        if (localStorage.getItem('user-info')) {
            navigate('/');
        }
    }, [navigate]);

  
    async function signUp() {
        const item = { name, email, password };
        const response = await fetch('http://localhost:8000/api/register', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            body: JSON.stringify(item),
        });
        
        const result = await response.json();
        
        if (response.ok) { 
            localStorage.setItem('user-info', JSON.stringify(result));
            navigate('/'); 
        } else {
            // Handle validation errors
            if (result.errors) {
                alert(result.errors.email ? 'Email already in use.' : result.message || 'Registration failed');
            } else {
                alert(result.message || 'Registration failed');
            }
        }
    }
    
    return (
        <div>
            <Header /><br/>
            <h1 style={{ textAlign: 'center' }}>Register </h1><br/>
            <div className='col-sm-6 offset-sm-3'>
                <input 
                    type="text" 
                    placeholder="name" 
                    onChange={(e)=>setName(e.target.value)} 
                    className='form-control' 
                />
                <br/>
                <input 
                    type="email" 
                    placeholder="email" 
                    onChange={(e)=>setEmail(e.target.value)} 
                    className='form-control' 
                />
                <br/>
                <input 
                    type="password" 
                    placeholder="password" 
                    onChange={(e)=>setPassword(e.target.value)} 
                    className='form-control' 
                />
                <br/>
                <button onClick={signUp} className='btn btn-primary'>Sign Up</button>
            </div>
        </div>
    );
}

export default Register;
